import { RootState } from 'types/root-state';
import { catalogueInitialState } from './slice';

const selectDomain = (state: RootState) => state.spl.catalogueData || catalogueInitialState;

export const selectTopCategories = (state: RootState) => selectDomain(state).data;

export const selectTopCategoriesNetwork = (state: RootState) => selectDomain(state).network;
